var React = require('react');

function SocialTwitter (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"instagram"},React.createElement("path",{"id":"social-twitter","d":"M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm7.3,9.4A7.28,7.28,0,0,0,21,7.6a6.53,6.53,0,0,1-2,.5,3.58,3.58,0,0,0,1.5-1.9,6,6,0,0,1-2.1.8,3.55,3.55,0,0,0-2.5-1,3.37,3.37,0,0,0-3.4,3.4,2.49,2.49,0,0,0,.1.8A9.69,9.69,0,0,1,5.5,6.6a3.29,3.29,0,0,0-.4,1.7,3.32,3.32,0,0,0,1.5,2.8,3.31,3.31,0,0,1-1.5-.4h0a3.54,3.54,0,0,0,2.7,3.4,2.77,2.77,0,0,1-.9.1,1.27,1.27,0,0,1-.6-.1,3.24,3.24,0,0,0,3.2,2.3A7,7,0,0,1,5.3,18a2,2,0,0,1-.8-.1,9.31,9.31,0,0,0,5.2,1.5,9.62,9.62,0,0,0,9.7-9.7V9.4Z","fill":"#FFF"})));
}

SocialTwitter.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = SocialTwitter;

SocialTwitter.default = SocialTwitter;
